import React from 'react'
import styled from 'styled-components/native'
import { PulsatingIcon } from '../Icon'

const Wrapper = styled.View<{ height: number; noBorderRadius?: boolean }>`
  width: 100%;
  height: ${({ height = 0 }) => height}px;
  border-radius: ${({ noBorderRadius, theme }) => (noBorderRadius ? 0 : theme.borderRadius.medium)}px;
  background-color: ${({ theme }) => theme.colors.secondaryBackground};
  justify-content: center;
  align-items: center;
`
export function ImageLoading({ noBorderRadius, width }: { noBorderRadius?: boolean; width: number }): React.ReactNode {
  return (
    <Wrapper height={width * (2 / 3)} noBorderRadius={noBorderRadius}>
      <PulsatingIcon icon={['fad', 'image']} />
    </Wrapper>
  )
}
